import * as React from 'react';
import { connect } from 'react-redux';

import { IPostcardImage, IDocument } from '../../infrastructure/interfaces';
import PostcardImageFrontEditorForm from '../DocumentEditor/PostcardImageFrontEditorForm';
import {
  changePostcardImageFront,
} from '../../actions/actions';

export interface IPostcardImagessChoosingProps {
  document: IDocument;
  postcardImagesList: IPostcardImage[];
  changePostcardImageFront(image: IPostcardImage): void;
}

export interface IPostcardImagessChoosingState { }

const mapDispatchToProps = (dispatch: any): any => {
  return {
    changePostcardImageFront: (image: IPostcardImage): void => {
      dispatch(changePostcardImageFront(image));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    postcardImagesList: state.wizard.postcardImages,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class PostcardImagessChoosing extends React.Component<any, any> {
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Choose the front postcard background image:
          </div>
          <div className="stepMessage2">
            You can change this selection later
        </div>
        </div>
        <PostcardImageFrontEditorForm
          className="stepContent settingsCropsListContainer settingsCropsListContainer--crops"
          document={this.props.document}
          postcardImagesList={this.props.postcardImagesList}
          onPostcardImageChangeFront={this.props.changePostcardImageFront}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/PostcardImageListFrontChoosing.tsx